export type StandingItem = { playerId: string; totalScore: number };

/** Competition ranking: tied scores share one rank; next rank skips (1,1,3,4). */
export function competitionRanks(standings: StandingItem[]): Map<string, number> {
  const sorted = [...standings].sort((a, b) => b.totalScore - a.totalScore);
  const ranks = new Map<string, number>();
  let rank = 1;
  for (let i = 0; i < sorted.length; i++) {
    if (i > 0 && sorted[i].totalScore < sorted[i - 1].totalScore) {
      rank = i + 1;
    }
    ranks.set(sorted[i].playerId, rank);
  }
  return ranks;
}

/** True when at least two players share the top score. */
export function isTie(standings: StandingItem[]): boolean {
  if (standings.length < 2) return false;
  const sorted = [...standings].sort((a, b) => b.totalScore - a.totalScore);
  return sorted[0].totalScore === sorted[1].totalScore;
}
